
import './axios'
import './fontawesome'
import 'bootstrap'
import './vue-multiselect'
import './uiv'
import './mask'
// import './vue-outside-events'
// import './bootstrap-vue'
window.Popper = require('popper.js').default;

try {
    window.$ = window.jQuery = require('jquery')
    require('bootstrap-sass')
} catch (e) {}

window.axios = require('axios')

window._ = require('lodash')



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/index.js